import { Button, ButtonLink, Stack } from '@fukuri-admins/ui/common';
import { TextInputFieldController } from '@fukuri-admins/ui/common/Form';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

type Props = {
  title: string;
  isSubmitDisabled: boolean;
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
};

export const EditClientAdminUserFormPresentation: React.FC<Props> = ({
  title,
  isSubmitDisabled,
  onSubmit,
}) => (
  <form onSubmit={onSubmit} className={styles.form}>
    <Stack direction='column' gap={24}>
      <h2 className={styles.formTitle}>{title}</h2>
      <div className={styles.formContainer}>
        <Stack direction='column' gap={24}>
          <TextInputFieldController
            name='fullName'
            fieldWrapperProps={{
              labelText: '氏名',
              labelType: 'required',
            }}
            textInput={{
              placeholder: '福利 太郎',
            }}
          />
          <TextInputFieldController
            name='email'
            fieldWrapperProps={{
              labelText: 'メールアドレス',
              labelType: 'required',
            }}
            textInput={{
              type: 'email',
              placeholder: 'fukuri@example.com',
            }}
          />
          <TextInputFieldController
            name='password'
            fieldWrapperProps={{
              labelText: 'パスワード',
              beforeMessage: '変更する場合のみ入力してください。8文字以上。',
            }}
            textInput={{
              type: 'password',
            }}
          />
          <TextInputFieldController
            name='passwordConfirmation'
            fieldWrapperProps={{
              labelText: 'パスワード確認',
            }}
            textInput={{
              type: 'password',
            }}
          />
        </Stack>
      </div>
      <Stack direction='row' gap={8}>
        <ButtonLink to={ROUTES.ADMINS.INDEX} variant='secondary'>
          キャンセル
        </ButtonLink>
        <Button type='submit' disabled={isSubmitDisabled}>
          保存
        </Button>
      </Stack>
    </Stack>
  </form>
);
